import { MenuDataLocale } from "../../menudata/types/MenuDataLocale";

export const getSurchargeText = (menuDataLocale: MenuDataLocale, surchargePercentage: number) =>
    `${menuDataLocale.surchargeText}${
        surchargePercentage > 0 ? ` (${menuDataLocale.formatPercent(surchargePercentage)})` : ""
    }`;
